<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.searchCardShow" :gutter="16">
                <Col span="24">
                    <search-card
                        :form="mainTable.searchForm"
                        :table-load-event="getCustomerManagerUserTableRecords"
                        :table-search="mainTable.tableSearch"
                    />
                </Col>
            </Row>
        </transition>
        <Card :padding="0" :bordered="false" :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">客户经理账户列表</span>
                        </div>
                        <div class="right-bar">
                            <Button
                                v-if="$checkAccessArray(['S'])"
                                size="small"
                                class="btns"
                                shape="circle"
                                type="success"
                                icon="ios-add-circle-outline"
                                @click="onCreateCustomerManagerUser"
                                >新增</Button
                            >
                            <Button
                                type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                @click="
                                    mainTable.searchCardShow =
                                        !mainTable.searchCardShow
                                "
                                >搜索</Button
                            >
                        </div>
                    </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                    <stand-pagination-table
                        :columns="mainTable.columns"
                        :data="mainTable.data"
                        :extHeight="60"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getCustomerManagerUserTableRecords"
                    />
                </Col>
            </Row>
        </Card>

        <CustomerManagerUserEdit ref="customerManagerUserModal"  :departmentList="departmentList" :companyList="companyList" />
        <CustomerManagerUserEditDept ref="customerManagerUserDeptModal" />
    </div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import { approvalFormat, statusFormat } from "@/libs/baseModelFormat";
import { dateTimeRender } from "@/libs/tableRowTimeRender";
import CustomerManagerUserEdit from "./customerManager-user-edit";
import CustomerManagerUserEditDept from "./customerManager-user-editDept";
import { getCustomerManagerUserList } from "@/api/modules/account-management/customerManager-user-management";
import { getDepartmentList } from "@/api/modules/system-management/department-management";
import { getCompanyList } from "@/api/modules/system-management/company-management";
export default {
    name: "CustomerManagerUserList",
    components: {
        SearchCard,
        StandPaginationTable,
        CustomerManagerUserEdit,
        CustomerManagerUserEditDept
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mainTable: {
                columns: [
                    {
                        title: "行号",
                        type: "index",
                        width: 80,
                        align: "center"
                    },
                    // { title: '编号', key: 'userCustomerManagerCode', align: 'center' },
                    {
                        title: "公司",
                        key: "projectCompany",
                        align: "center"
                    },
                    {
                        title: "部门",
                        key: "projectName",
                        align: "center"
                    },
                    {
                        title: "部门类型",
                        key: "projectType",
                        align: "center"
                    },
                    {
                        title: "姓名",
                        key: "userCustomerManagerName",
                        align: "center"
                    },
                    { title: "登录账号", key: "userName", align: "center" },
                    {
                        title: "关联用友部门",
                        key: "userCustomerManagerYsDeptCode",
                        align: "center"
                    },
                    {
                        title: "关联用友部门编号",
                        key: "userCustomerManagerYsDeptName",
                        align: "center"
                    },
                    {
                        title: "区域",
                        key: "areaName",
                        width: 80,
                        align: "center"
                    },
                    // { title: '部门', key: 'projectName', align: 'center' },
                    // { title: '公司', key: 'projectCompany', align: 'center' },
                    {
                        title: "手机号码",
                        key: "userCustomerManagerPhone",
                        width: 150,
                        align: "center"
                    },
                    {
                        title: "审核",
                        key: "userCustomerManagerApproval",
                        align: "center",
                        width: 80,
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "span",
                                    {},
                                    approvalFormat(
                                        params.row.userCustomerManagerApproval
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "创建时间",
                        key: "userCustomerManagerCreateAt",
                        align: "center",
                        render: (h, params) =>
                            dateTimeRender(
                                h,
                                params.row.userCustomerManagerCreateAt
                            )
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        width: 180,
                        render: (h, params) => {
                            const text = this.$checkAccessArray(["S", "G"])
                                ? "编辑"
                                : "查看";
                            const data = h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small"
                                        },
                                        style: {},
                                        on: {
                                            click: () => {
                                                this.onUpdateCustomerManagerUser(
                                                    params.row
                                                );
                                            }
                                        }
                                    },
                                    text
                                )
                            ]);
                            if (this.$checkAccessArray(["R", "S"])) {
                                data.children.push(h(
                                    'Button',
                                    {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {},
                                        on: {
                                            click: () => {
                                                this.onCustomerManagerDeptUpdate(params.row);
                                            }
                                        }
                                    },
                                    '修改YS部门信息'
                                ));
                            }
                            return data
                        }
                    }
                ],
                data: [],
                searchCardShow: false,
                searchForm: [
                    {
                        label: "登录账号",
                        type: "Input",
                        value: "",
                        name: "userName",
                        sql: "like"
                    },
                    {
                        label: "姓名",
                        type: "Input",
                        value: "",
                        name: "userCustomerManagerName",
                        sql: "like"
                    },
                    {
                        label: "审核状态",
                        type: "Select",
                        name: "userCustomerManagerApproval",
                        sql: "in",
                        options: [
                            { value: 1, key: "通过" },
                            { value: 0, key: "未通过" }
                        ]
                    }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            companyList: [],
            departmentList: []
        };
    },
    created() {
        if (this.readOnly) {
            const findIndex = this.mainTable.columns.findIndex(
                (c) => c.title === "操作"
            );
            if (findIndex >= 0) {
                this.mainTable.columns.splice(findIndex, 1);
            }
        }
    },
    async mounted() {
        await this.getCustomerManagerUserTableRecords();
        await this.getCompanyList();
        await this.getDepartmentList();

    },
    methods: {
        getCustomerManagerUserTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            getCustomerManagerUserList(this.mainTable.tableSearch)
                .then((res) => {
                    if (res.code === 0) {
                        this.mainTable.data = res.data.records;
                        search.globalSetFilterRecordCount(
                            this.mainTable.tableSearch,
                            res.data.filterRecordCount
                        );
                    }
                    else {
                        this.$Message.error(res.message || '获取客户经理用户列表失败');
                    }
                })
                .catch((error) => {
                    console.error('获取客户经理用户列表失败:', error);
                    this.$Message.error('获取客户经理用户列表失败');
                })
                .finally(() => {
                    this.mainTable.loading = false;
                });
        },
        onCreateCustomerManagerUser() {
            this.$refs.customerManagerUserModal.showModal("");
            // this.$router.push({
            //     name: 'customerManager-user-edit',
            //     query: {
            //         userCustomerManagerLoginUuid: ''
            //     }
            // });
        },
        async getCompanyList() {
            const params = search.closeAllConditions(search.getSearchParams());
            try {
                const res = await getCompanyList(params);
                if (res.code === 0) {
                    this.companyList = res.data.records;
                }
                return [];
            }
            catch (error) {
                console.error("Failed to fetch companies:", error);
                return [];
            }
        },
        async getDepartmentList() {
            const params = search.closeAllConditions(search.getSearchParams());
            try {
                const res = await getDepartmentList(params);
                if (res.code === 0) {
                    this.departmentList = res.data.records;
                }
                return [];
            }
            catch (error) {
                console.error("Failed to fetch departments:", error);
                return [];
            }
        },
        async onUpdateCustomerManagerUser(customerManagerUserRow) {
            this.$refs.customerManagerUserModal.showModal(
                customerManagerUserRow.userCustomerManagerLoginUuid,
                this.companyList,
                this.departmentList
            );
        },
        async onCustomerManagerDeptUpdate(customerManagerUserRow) {
            this.$refs.customerManagerUserDeptModal.showModal(
                customerManagerUserRow.userCustomerManagerLoginUuid,
                this.companyList,
                this.departmentList
            );
        }
    }
};
</script>

<style scoped></style>
